import * as React from "react";
import { SVGProps } from "react";

const OutlineArrowRight = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="current"
    {...props}
  >
    <path d="M10.7399 16.2799C10.5499 16.2799 10.3599 16.2099 10.2099 16.0599C9.91993 15.7699 9.91993 15.2899 10.2099 14.9999L13.2099 11.9999L10.2099 8.99991C9.91993 8.70991 9.91993 8.22991 10.2099 7.93991C10.4999 7.64991 10.9799 7.64991 11.2699 7.93991L14.7999 11.4699C15.0899 11.7599 15.0899 12.2399 14.7999 12.5299L11.2699 16.0599C11.1199 16.2099 10.9299 16.2799 10.7399 16.2799Z" />
  </svg>
);
export default OutlineArrowRight;
